<!-- 
    LISTAGEM DE TRANSPORTADORA FORÇA DE VENDAS
-->

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import CustomerForm from '../forms/customer-form'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codpart: '',
            metadata: this.$store.getters.getEntities.metadata,
        }
    },

    computed: {
        partList: function () {
            return this.$store.getters.getPartList
        },

        controleLimiteCredito: function () {
            return true
        },
    },

    methods: {
        editPart (codpart) {
            //abre a tela de edicao
            this.crud = SysVars.crudU //update
            this.codpart = codpart
            this.showForm = true; 
        },

        incluirPart (codpart) {
            //abre a tela de edicao
            this.crud = SysVars.crudI
            this.codpart = codpart
            this.showForm = true;
        },

        onAction (action) {

        },

        closeForm () {
            this.showForm = false
        },

        search (value) {
            this.filter = '{"$or":[{"nome":{"$like":"' + value + '%25"}},{"fantasia":{"$like":"' + value + '%25"}},{"codpart":{"$eq":"' + value + '"}},{"cnpjcpf":{"$eq":"' + value + '"}}]}'
            this.loadData()
        },

        loadData () {
            this.$store.dispatch('loadTransportadoras', { filter: this.filter } )
        },

    },

    components: {
        BarList, BarGrid, CustomerForm
    },

    mounted() {

    },

    beforeDestroy() {

    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div id="grid">
        <div id="list"> 

            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="true"
                :xls-button="true"
                single-entity="Transportadora" 
                plural-entity="Transportadoras"
                @search="search"
                @new="incluirPart"
                @refresh="loadData">
            </bar-list>

            <div class="default-container nb-card-list nb-margin-top">
                <alert v-if="partList.length == 0" type="norecord"></alert>

                <article class="nb-card" v-for="(part, index) in partList" :key="part.codpart || index">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-truck" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ part.nome }}</h2>
                                    <span v-if="part.fantasia && part.fantasia !== part.nome" class="nb-card-badge nb-card-badge--neutral">
                                        {{ part.fantasia }}
                                    </span>
                                </div>
                                <div class="nb-card-code">
                                    <span v-if="part.cnpjcpf">CNPJ/CPF <strong>{{ part.cnpjcpf | formatCNPJCPF }}</strong></span>
                                    <span v-if="part.codpart" class="ml-2">Código <strong>{{ part.codpart }}</strong></span>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid 
                                :options="{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'}" 
                                :moreActions="[]" 
                                @edit="editPart(part.codpart)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details" v-if="part.nomemun || part.fone1 || part.email">
                        <div class="nb-card-detail" v-if="part.nomemun || part.uf">
                            <span class="nb-card-detail-label">Localização</span>
                            <strong><i class="fa fa-map-marker mr-1" aria-hidden="true"></i> {{ part.nomemun }} - {{ part.uf }}</strong>
                        </div>
                        <div class="nb-card-detail" v-if="part.fone1 || part.fone2 || part.fone3">
                            <span class="nb-card-detail-label">Telefone</span>
                            <strong><i class="fa fa-phone mr-1" aria-hidden="true"></i> {{ part.fone1 | formatFone }} <span v-if="part.fone2">/ {{ part.fone2 | formatFone }}</span></strong>
                        </div>
                        <div class="nb-card-detail" v-if="part.email">
                            <span class="nb-card-detail-label">E-mail</span>
                            <strong><i class="fa fa-envelope-o mr-1" aria-hidden="true"></i> {{ part.email }}</strong>
                        </div>
                    </div>
                </article>

            </div>

        </div>

        <div class="nb-modal-scrollable" v-if="showForm">
            <div class="container nb-modal-scrollable-container" style="width: 800px; max-width: 100%">
                <div class="nb-modal-scrollable-body">
                    <customer-form :crud="crud" :index="codpart" :transportadora="true" @closeform="closeForm"></customer-form>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--neutral {
  color: #475569;
  background: #f1f5f9;
  border-color: #e2e8f0;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/transportadora-list.vue